import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from '../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'studentNo', label: '学号', width: 160},
    {key:'name', label: '姓名'},
    {key:'birthday', label: '生日', render: (value)=> (value ? moment(new Date(value)).format('YYYY/MM/DD') : '--'), width: 180},
    {key:'sex', label: '性别', render: (value) => value === 1 ? '男' : '女'},
    {key:'orgName', label: '所属部门'},
    {key:'classGrade', label: '年级'},
    {key:'classesName', label: '班级', width: 200}
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('student/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method remove
 * @param {array} data [id: int, ...]
 * @return {promise}
 */
const setUserPassword = (data) => {
    return fetch.post('student/reset/pwd', data)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method setUserPwd
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const setUserPwd = (domain) => {
    const data = {
        loginName: domain.loginName,
        id: domain.setAllPwd === true ? 0 : DataGrid.selections[0],
        newPwd: domain.newPwd
    }

    setUserPassword(data).then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.selections = [];
            DataGrid.refresh();
        }
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('student/listByLegislationAssign', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('student/find/by/name', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.id,
            label: d.name,
            studentNo: d.studentNo
        }));
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('student/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
        return response;
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('student/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('student/remove/', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.refresh();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'student'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

const queryPropertiesList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/student/property', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

//公共班级id获取学生总数
const findByClassesId = (classesId) =>{
    return fetch.post('student/find/by/' + classesId)
    .then (response =>{
        return response.payload.data;
    })
}

export default {
    insertURL: '#/student/insert',
    querySearchById,
    insert,
    update,
    querySearch,
    querySearchByName,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    setUserPwd,
    queryPropertiesList,
    findByClassesId
}